(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'lodash/drop', '../util/convert'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('lodash/drop'), require('../util/convert'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.drop, global.convert);
    global.drop = mod.exports;
  }
})(this, function (exports, _drop2, _convert) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = exports.drop = undefined;

  var _drop3 = _interopRequireDefault(_drop2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /**
   * Replaces an array dropping one or several elements at the start of the former array.
   * @function
   * @memberof array
   * @param {Object} object The object to modify.
   * @param {Array|string} path The path of the property to set.
   * @param {number} [n=1] The number of elements to drop.
   * @return {Object} Returns the updated object.
   * @example drop({ nested: { prop: [1, 2, 3, 4] } }, 'nested.prop', 2) // => { nested: { prop: [3, 4] } }
   * @see {@link https://lodash.com/docs#drop|lodash.drop} for more information.
   * @since 0.2.0
   */
  var drop = (0, _convert.convert)(_drop3.default);
  exports.drop = drop;
  exports.default = drop;
});